import { render, staticRenderFns } from "./doctors.vue?vue&type=template&id=1c49a75f&"
import script from "./doctors.vue?vue&type=script&lang=js&"
export * from "./doctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports